import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators, compose } from 'redux';
import values from 'lodash/values';
import get from 'lodash/get';

import { parseQueryString } from '../../shared/utils';

import {
  loadPaymentMethodsForAgency,
  createPaymentMethod,
  loadAgencyWithChildren
} from '../../shared/redux/entities/actions';

import {
  addFundsToAgency,
  createIO
} from '../../shared/redux/accounting/actions';


function getPaymentMethodsForAgency(state,agencyId){
  if(agencyId){
    return values(state.entities.paymentMethods)
      .filter((p) => p.agencyId === agencyId);

  } else {
    return [];
  }
}


function mapStateToProps(state,props){
  const accountId = props.accountId || props.match.params.accountId,
    queryStringParams = parseQueryString(props.location.search);

  return {
    redirectURL:queryStringParams['redirect'] || null,
    userId:get(state,['entities','activeUserId']),
    accountId:accountId,
    paymentMethods:getPaymentMethodsForAgency(state,accountId)
  };
}

function mapDispatchToProps(dispatch){
  //TODO: Bind Redux action creators to AccountNewPaymentMethod
  return bindActionCreators({ loadPaymentMethodsForAgency, createPaymentMethod, loadAgencyWithChildren },dispatch);
}

export default compose(
  withRouter,
  connect(mapStateToProps,mapDispatchToProps)
);



// WEBPACK FOOTER //
// ./src/routes/AccountNewPaymentMethod/connect.js